import { Observable } from 'rxjs'
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable()
export class HttpServiceHelper {

  httpOptions: any = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      ...(environment.isLocal) && {"Authorization": "Bearer " + localStorage.getItem('auth-token')},
    },
    )
  };

  constructor(private http: HttpClient) {
  }



  public httpGetRequestWithParams(url: string, param: HttpParams) {
    return this.http.get(url, { ...this.httpOptions, params: param })
      .map(response => {
        return response;
      })
      .catch(response => (Observable.throw(response)
      ));
  }

  /**
   * Security Fix: Graph API user search using $batch POST to keep PII in request body instead of URL.
   * Use this instead of httpGetRequestWithParams for all Microsoft Graph /users searches.
   * Returns the same response shape as a direct GET: { value: [...] }
   */
  public httpGraphUserSearch(value: string) {
    const batchRequest = {
      requests: [{
        id: '1',
        method: 'GET',
        url: `/users?$filter=((startswith(displayName,'${value}') or startswith(mail,'${value}')))`
      }]
    };
    return this.http.post('https://graph.microsoft.com/v1.0/$batch', batchRequest, this.httpOptions)
      .map((res: any) => res.responses?.[0]?.body)
      .catch(response => (Observable.throw(response)));
  }

  public httpGetRequest(url: string) {
    return this.http.get(url)
      .map(response => {
        return response;
      })
      .catch(response => (Observable.throw(response)
      ))
  }

}
